import {Authentication, authenticationDecoder} from './Authentication'
import {Cis2User, cis2UserDecoder} from '../Entities/Cis2User'
import {Manufacturer, manufacturerDecoder} from '../Entities/Manufacturer.entity.evolve'
import {Decoder, field, object} from 'json-bouncer'

export interface Session {
    readonly authentication: Authentication
    readonly cis2User: Cis2User
    readonly manufacturer: Manufacturer
}

export function sessionDecoder(): Decoder<Session> {
    return object({
        authentication: field('authentication', authenticationDecoder()),
        cis2User: field('cis2User', cis2UserDecoder()),
        manufacturer: field('manufacturer', manufacturerDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Session.ts